define('commons/azimuth-event',['jquery', 'commons/azimuth-selector', 'commons/tilt-selector'], function($, Compass, Tilt) {

    var AzimuthEvent = function() {
        var onChangeAzimuth = function(angle){
            $('#azimuth').val(angle); 
        };
        var onChangeAttenuationDirect = function(angle){
            $('#attenuationDirect').val(angle); 
        };
        var onChangeAttenuationIndirect = function(angle){
            $('#attenuationIndirect').val(angle); 
        };
        var onChangeAttenuation = function(attenuation){
            $('#attenuation').val(attenuation); 
            $('#attenuationSlider').slider('value', 0);
        };

        var notEnterKey = function(event){
            // 13 : Enter key
            if (event.keyCode == 13) 
                event.preventDefault();

        };
        var compass = new Compass('#azimuthSelector', {'onChangeAzimuth' : onChangeAzimuth,
                                               'onChangeAttenuationDirect' : onChangeAttenuationDirect,
                                               'onChangeAttenuationIndirect' : onChangeAttenuationIndirect,
                                               'onChangeAttenuation' : onChangeAttenuation,
                                               'width':300, 'height':300, 'radius':100});
        $( "#attenuationSlider" ).slider({
            value: 0,
            orientation: "horizontal",
            range: 'min',
            animate: true,
            min: 0,
            max: 100,
            slide: function(event, ui) {
                $('#attenuation').val(ui.value).change();
                $('.ui-slider-range').css('background', 'rgba(255, 0, 0, '+ui.value/100+')');
              } 
          });
        $('#azimuth').change(function(){
            var val = $(this).val();
            if(!isNaN(parseFloat(val))){
                compass.setAzimuth(val);
            }
        }).keypress(notEnterKey).change();
        $('#attenuationDirect').change(function(){
            var val = $(this).val();
            if(!isNaN(parseFloat(val))){
                compass.setAttenuationDirect(val);
            }
        }).keypress(notEnterKey).change();
        $('#attenuationIndirect').change(function(){
            var val = $(this).val();
            if(!isNaN(parseFloat(val))){
                compass.setAttenuationIndirect(val);
            }
        }).keypress(notEnterKey).change();
        $('#attenuation').change(function(){
            var val = $(this).val();
            if(!isNaN(parseFloat(val))){
                compass.setAttenuation(val);
                $('#attenuationSlider').slider('value',val);  
                $('.ui-slider-range').css('background', 'rgba(255, 0, 0, '+ val/100+')');
            }
        }).keypress(notEnterKey).change();
        var lock = $( '#lock' );
        $( '#drawAttenuation' ).button({ text: false, icons: { primary: 'icon-pencil' } }).click(function(){
            if ($(this).is(':checked')) {
                compass.setDrawingMode(true);
            } else {
                compass.setDrawingMode(false);
            }
        });
        lock.button({ text: false, icons: { primary: 'icon-lock' } }).click(function(){
            var options;
            if ($(this).is(':checked')) {
                options = {
                        text: false,
                        icons: {
                          primary: 'icon-unlock'
                        }
                      };
                compass.setLock(true);
            } else {
                options = {
                        text: false,
                        icons: {
                          primary: 'icon-lock'
                        }
                      };
                compass.setLock(false);
            }
            $( this ).button( 'option', options );
        });
        $('#clearAttenuation').button({ text: false, icons: { primary: 'icon-eraser' } }).click(function(){
            compass.clearAttenuation();
        });

        var onChangeTilt = function(angle){
            $('#tilt').val(angle); 
        };

        var tilt = new Tilt('#tiltSelector', {'onChangeTilt' : onChangeTilt, 'width':200, 'height':275, 'radius':100});

        $('#tilt').change(function(){
            var val = $(this).val();
            if(!isNaN(parseFloat(val))){
                tilt.setTilt(val);
            }
        }).keypress(notEnterKey).change();

        $('#resetValues').button().click(function(){
            compass.clearAttenuation();
            tilt.setTilt(0);
            compass.setAzimuth(0);
            $('input.attenuations').each(function() {
                $(this).val("0.0");
            })
        });

        var antennaBlock = $('#antenna');
        $('#model').change(function(){
            var val = $(this).val();
            if( val !== '') {
                antennaBlock.slideDown();
            } else {
                antennaBlock.slideUp();
            }
        }).change();
    };

    return AzimuthEvent;
});

